import React from 'react';
import { CameraOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import { Image } from 'components/Atoms';

import DefaultAvatar from 'assets/images/profile/defaultAvatar.png';

import './style.scss';

const UploadAvatar = ({ avatar, handleChange, className = '', isViewOnly }) => {
  return (
    <div className={`avatar-wrapper ${className}`}>
      <div className="edit-avatar mb-10">
        <Image alt="avatar" className="avatar" src={avatar || DefaultAvatar} />
        {!isViewOnly && (
          <>
            <label>
              <input
                style={{ display: 'none' }}
                type="file"
                accept="image/x-png,image/gif,image/jpeg"
                multiple={false}
                onChange={handleChange}
              />
              <div className="upload-part">
                <span className="label">
                  <CameraOutlined /> Change Picture
                </span>
              </div>
            </label>
          </>
        )}
      </div>
    </div>
  );
};

export default UploadAvatar;

UploadAvatar.propTypes = {
  avatar: PropTypes.string,
  handleChange: PropTypes.func,
};

UploadAvatar.defaultProps = {
  avatar: '',
  handleChange: () => {},
};
